import { render } from "./ConversationHistoryRedirect.vue?vue&type=template&id=29784c38"
import script from "./ConversationHistoryRedirect.vue?vue&type=script&lang=js"
export * from "./ConversationHistoryRedirect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__